import moment from 'moment'
import isEmpty from 'lodash/isEmpty'

const YYYY_MM_DD = 'YYYY-MM-DD'
const HH_mm_ss = 'HH:mm:ss'
const YYYY_MM_DD_HH_MM = 'MM/DD/YYYY, HH:mm'
const YYYY_MM_DD_HH_MM_12_HOURS = 'MM/DD/YYYY, hh:mm A'
const YYYY_MM_DD_HH_MM_SS = 'MM/DD/YYYY, HH:mm:ss'
const YYYY_MM_DD_HH_MM_SS_12_HOURS = 'MM/DD/YYYY, hh:mm:ss A'
const HH_MM_MMMM_DD_YYYY = 'HH:mm A MMMM DD,YYYY, '
const DD_MM_YYYY = 'MM/DD/YYYY'
const HH_MM = 'HH:mm'
const HH_MM_12_HOURS = 'hh:mm A'
const HH_MM_SS_12_HOURS = 'hh:mm:ss A'
const dddd_DD_MMM_YYYY = 'dddd, DD MMM, YYYY'
const DD_MM_YYYY2 = 'DD-MM-YYYY'

export const convertDateTo_Date = date => {
  return moment(date)
}

export const convertDateToFormattedDate = date => {
  return moment(date, YYYY_MM_DD)
}

export const convertTimeToFormattedDate = date => {
  return moment(date, HH_mm_ss)
}

export const convertDateTo_YYYY_MM_DD = date => {
  return moment(date, YYYY_MM_DD).format(YYYY_MM_DD)
}

export const convertDateTo_DD_MM_YYYY = date => {
  return moment(date, YYYY_MM_DD).format(DD_MM_YYYY2)
}

export const convertDateTo_HH_mm_ss = date => {
  return moment(date, HH_mm_ss).format(HH_mm_ss)
}

export const convertDateTo_HH_mm = date => {
  return moment(date, HH_mm_ss).format(HH_MM)
}

export const convertDateToDisplayDateAndTime = (date, isDateShow12HoursFormat = false) => {
  if (date) {
    return moment(date).format(isDateShow12HoursFormat ? YYYY_MM_DD_HH_MM_12_HOURS : YYYY_MM_DD_HH_MM)
  }
  return ''
}
export const convertDateToDisplayDateAndTimeWithSeconds = (date, isDateShow12HoursFormat= false) => {
  if (date) {
    return moment(date).format(isDateShow12HoursFormat ? YYYY_MM_DD_HH_MM_SS_12_HOURS : YYYY_MM_DD_HH_MM_SS)
  }
  return ''
}

export const convertDateToDisplayDate = date => {
  if (date) {
    return moment(date).format(DD_MM_YYYY)
  }
  return ''
}
export const convertDateToDisplayTime = (date, isTimeShow12HoursFormat = false) => {
  if (date) {
    return moment(date).format(isTimeShow12HoursFormat ? HH_MM_12_HOURS : HH_MM)
  }
  return ''
}
export const convertDateToDisplayTimeWithSeconds = (date, isTimeShow12HoursFormat = false) => {
  if (date) {
    return moment(date).format(isTimeShow12HoursFormat ? HH_MM_SS_12_HOURS : HH_mm_ss)
  }
  return ''
}
export const convertDateTo_YYYY_MM_DD_T_HH_mm_ss = (date, time) => {
  if (time) {
    return convertDateTo_YYYY_MM_DD(date) + 'T' + convertDateTo_HH_mm_ss(time)
  }
  return convertDateTo_YYYY_MM_DD(date) + 'T' + '00:00:00'
}

const getMillisecondsFromDate = date => {
  return new Date(date).getTime()
}

const getMillisecondsFromMinutes = minutes => {
  return minutes * 60000
}
const getDateFromMilliseconds = milliseconds => {
  return moment(milliseconds).format(YYYY_MM_DD + 'T' + HH_mm_ss)
}

export const addOffset = (date, offset) => {
  const milisecs = getMillisecondsFromDate(date)
  const offsetMiliSecs = getMillisecondsFromMinutes(offset)
  return getDateFromMilliseconds(milisecs + offsetMiliSecs)
}

export const subtractFromDate = (date, unit, value) => {
  return convertDateTo_YYYY_MM_DD_T_HH_mm_ss(
    moment(date)
      .subtract(unit, value)
      .format(YYYY_MM_DD)
  )
}

export const subtractDate = (date, unit, value) => {
   return moment(date)
      .subtract(unit, value).toDate()
}

export const addFromDate = (date, unit, value) => {
  return convertDateTo_YYYY_MM_DD_T_HH_mm_ss(
    moment(date)
      .add(unit, value)
      .format(YYYY_MM_DD)
  )
}

export const addDate = (date, unit, value) => {
   return moment(date)
      .add(unit, value).toDate()
}
export const isOverlappingTime = (currentStartTime,currentEndTime,startTime)=> {
  const format = 'hh:mm:ss'
  const time = moment(currentStartTime,format),
    beforeTime = moment(startTime, format)
  
  if ( time.isSame(beforeTime) && currentEndTime) {
  
 return true
  
  }
  return false

}

export const addTimeInMinutes = (time, value) => moment(time, 'HH:mm:ss').add(value, 'minutes').format('HH:mm:ss')

export const isSameOrAfter = (date1, date2) => {
  return moment(date1).isSameOrAfter(date2)
}

export const isBefore = (date1, date2) => {
  return moment(date1).isBefore(date2)
}

export const convert_YYYY_MM_DD_toUTC=(date)=>{
  return `${date}T00:00:00`
}

export const isAfter = (date1, date2) => {
  return moment(date1).isAfter(date2)
}

export const isSameOrBefore = (date1, date2) => {
  return moment(date1).isSameOrBefore(date2)
}

export const convertTo_dddd_DD_MMM_YYYY = date => {
  if (date) {
    return moment(date, YYYY_MM_DD).format(dddd_DD_MMM_YYYY)
  }
  return ''
}

export const getTimeFromX = (date, fromDate) => {
  if (date && fromDate) {
    return moment(date, `${YYYY_MM_DD}T${HH_mm_ss}`).from(fromDate)
  }
  return ''
}

export const isVaildDOB = (date1) => {
  date1 = moment(date1).format(YYYY_MM_DD)
  return moment(date1).isSameOrBefore(moment())
}

export const getUtcDate = () => moment.utc().format(`${YYYY_MM_DD}T${HH_mm_ss}`)

export const sortBasedOnDate = (dateA, dateB) => {
  const date1 = new Date(dateA)
  const date2 = new Date(dateB)
  if (date1 < date2) {
    return 1
  }
  if (date1 > date2) {
    return -1
  }
  return 0
}

// Date comparator for react-table sortType. Returns standard compare order;
// react-table applies ASC/DESC by inverting this result.
export const sortByDate = (dateA, dateB) => {
  if (!dateA && !dateB) {
    return 0
  }
  if (!dateA) {
    return 1
  }
  if (!dateB) {
    return -1
  }
  const momentA = moment(dateA)
  const momentB = moment(dateB)
  if (!momentA.isValid() && !momentB.isValid()) {
    return 0
  }
  if (!momentA.isValid()) {
    return 1
  }
  if (!momentB.isValid()) {
    return -1
  }
  return momentA.valueOf() - momentB.valueOf()
}

export const isDateBetween = (date, startDate, endDate) => {
  return moment(date).isBetween(startDate, endDate, null, '[]')
}

export const isSameDayAndMonth = (date1, date2) => {
  if (date1 && date2) {
    date1 = moment(date1)
    date2 = moment(date2)
    return date1.date() === date2.date() && date1.month() === date2.month()
  }
  return false
}
export const convertDateFrom_MM_DD_YYYY = (date) =>{
  let FormatedDate = date ? moment(date, 'MM-DD-YYYY').format('YYYY/MM/DD') : undefined
  FormatedDate = moment(FormatedDate).format('YYYY/MM/DD')
  return FormatedDate
}
export const getTimeDifference=(date1,date2) =>{
  return moment(date1, 'HH:mm:ss').diff(moment(date2, 'HH:mm:ss'))
}
export const getAgeFromDateOfBirth = (date) => {
  return moment().diff(date, 'years',false)
} 

export const isBeforeTime = (time1, time2, format='hh:mm') =>{
  return moment(time1, format).isBefore(moment(time2, format))
}

export const isSameDay = (date1, date2) => {
  return moment(date1).isSame(date2, 'day')
}
export const convertIn12HoursFormat = (time) => {
  const convertIn12HoursTimeFormat = moment(time, 'hh:mm:ss').format('hh:mm:ss A')
  if(convertIn12HoursTimeFormat === 'Invalid date') {
    return time
  } 
  return convertIn12HoursTimeFormat
}
export const fromNowDate = (date1, date2) => {
  if ( date1 && date2) {
    date1 = moment(date1)
    date2 = moment(date2)
    return date1.from(date2)
  }
  return false
}
export const convertDateToDisplayDateAndTime2 = date => {
  if (date) {
    return moment(date).format(HH_MM_MMMM_DD_YYYY)
  }
  return ''
}
export const checkExpiredTimeByUTC = (expiryTime) => {
  if(isEmpty(expiryTime)) return false
  expiryTime = moment(expiryTime).utc().format(`${YYYY_MM_DD}T${HH_mm_ss}`)
  return isSameOrAfter(expiryTime, getUtcDate())
}
export const isSameOrBeforeByTime = (date1, date2, format='HH:mm:ss' ) => {
  date1 = moment(date1, format)
  date2 = moment(date2, format)
  return moment(date1).isSameOrBefore(date2)
}
export const isSameOrAfterByTime = (date1, date2, format='HH:mm:ss' ) => {
  date1 = moment(date1, format)
  date2 = moment(date2, format)
  return moment(date1).isSameOrAfter(date2)
}
export const defaultDateFormat = date => {
  if (isEmpty(date)) {
    return undefined
  }
  return moment(new Date(date)).format(YYYY_MM_DD)
}
export const addNumberOfDaysInDate = (date, number) => {
  return moment
    .utc(date, 'YYYY-MM-DD')
    .add(number - 1, 'days')
    .format('YYYY-MM-DD')
}
